import React from 'react'
import { FaciLetter, File } from "components";

function Documents({ loan }) {

    return (
        <div>
            {loan?.adminStage === "pendingFacilityLetter" && loan?.state === "approved" && !loan?.facilityLetterUploaded && (
                <FaciLetter loan={loan} />
            )}

            <div className="mb-2">
                <h3 className="text-base font-semibold text-gray-900 dark:text-white/[.9]">
                    Client Documents
                </h3>
                <p className="mt-0.5 text-sm text-gray-500 dark:text-white/[.5]">
                    Other supporting documents uploaded.
                </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-1 sm:gap-4 py-3.5">
                <dt className="text-sm text-gray-500 dark:text-white/[.5]">Attachments</dt>
                <dd className="text-sm text-gray-900 dark:text-white/[.8] sm:col-span-2">
                    <ul className="divide-y divide-gray-100 dark:divide-white/[.08] rounded-lg border border-gray-200 dark:border-white/[.1]">
                        {loan?.files && loan?.files.length > 0 ? (
                            loan?.files?.map((file, index) => (
                                <File key={index} item={file} id={loan?.loanId} />
                            ))
                        ) : (
                            <li className="flex items-center justify-between py-4 pl-4 pr-5 text-sm text-gray-500 dark:text-white/[.5]">
                                <p>
                                    No attachments uploaded
                                </p>
                            </li>
                        )}
                    </ul>
                </dd>
            </div>
        </div>
    )
}

export default Documents